import axios from 'axios';
import config from '../utils/config';

// URL base de la API
const API_URL = config.API_URL;

// Instancia de axios para las peticiones
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir el token a las peticiones
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Servicio de analítica
const analyticsService = {
  // Obtener ingresos por período
  async getRevenueByPeriod(filters = {}) {
    try {
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filters.branchId) params.append('branch_id', filters.branchId);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      if (filters.periodType) params.append('period_type', filters.periodType);
      
      const response = await axiosInstance.get(`/analytics/revenue_by_period/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener ingresos por período:', error);
      throw error;
    }
  },
  
  // Obtener promedio de clientes por día
  async getClientsByDay(filters = {}) {
    try {
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filters.branchId) params.append('branch_id', filters.branchId);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      
      const response = await axiosInstance.get(`/analytics/clients_by_day/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener promedio de clientes por día:', error);
      throw error;
    }
  },
  
  // Obtener promedio de clientes por hora
  async getClientsByHour(filters = {}) {
    try {
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filters.branchId) params.append('branch_id', filters.branchId);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      
      const response = await axiosInstance.get(`/analytics/clients_by_hour/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener promedio de clientes por hora:', error);
      throw error;
    }
  },
  
  // Obtener clientes por asesor
  async getClientsByAdvisor(filters = {}) {
    try {
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filters.branchId) params.append('branch_id', filters.branchId);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      
      const response = await axiosInstance.get(`/analytics/clients_by_advisor/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener clientes por asesor:', error);
      throw error;
    }
  },
  
  // Obtener resumen del dashboard
  async getDashboardSummary(filters = {}) {
    try {
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filters.branchId) params.append('branch_id', filters.branchId);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      
      const response = await axiosInstance.get(`/analytics/dashboard_summary/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen del dashboard:', error);
      throw error;
    }
  }
};

export default analyticsService;
